import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconTaskWallet = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="yfm-icon yfm-icon-task-wallet"
      {...omit(props, ["className"])}
      ref={ref}
    >
      <g clipPath="url(#clip0_2057_301)">
        <path
          d="M7.471 2.67729C7.471 2.51564 7.34097 2.3845 7.18058 2.3845H0.790409C0.630032 2.3845 0.5 2.51564 0.5 2.67729V7.04346C0.5 7.20541 0.630032 7.33655 0.790409 7.33655H7.18058C7.34097 7.33655 7.471 7.20541 7.471 7.04346V5.92998H5.64114V5.92972C5.63623 5.92998 5.63148 5.92998 5.62657 5.92998C5.04111 5.92998 4.56646 5.4512 4.56646 4.86039C4.56646 4.26986 5.04111 3.7908 5.62657 3.7908C5.63148 3.7908 5.63635 3.79107 5.64114 3.79107V3.7908H7.471V2.67729ZM5.00204 4.86039C5.00204 5.20827 5.28168 5.49047 5.62657 5.49047C5.97158 5.49047 6.25107 5.20827 6.25107 4.86039C6.25107 4.51248 5.97158 4.23058 5.62657 4.23058C5.28168 4.23058 5.00204 4.51248 5.00204 4.86039ZM6.41325 0.838336C6.37703 0.71016 6.2443 0.636005 6.1167 0.672298L1.08151 2.11185H6.77392L6.41325 0.838336Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2057_301">
          <rect
            width="7"
            height="7"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
);

IconTaskWallet.displayName = "IconTaskWallet";

export default IconTaskWallet;
